/**
 * Shared thesis-break valve theta bounds/default. Previously duplicated as
 * local consts in ConvictionStrip.tsx and ValvePanel.tsx.
 */
export const THETA_MIN = 0.5
export const THETA_MAX = 0.95
export const THETA_DEFAULT = 0.8
